import(/* webpackMode: "eager" */ "/builds/src/app/(events)/events/new-subscribe/index/page.jsx");
